import { ArrowDownward } from "@material-ui/icons";
import "./skill.css";
import {useEffect, useState } from 'react';
import { HTTP } from "../../api/http-common";


function Skill() {
  const [data, setData] = useState(null);

  let technologies = [
    {
      id: 1,
      imgUrl: "assets/language-images/p.jpg",
    },
    {
      id: 2,
      imgUrl: "assets/language-images/dj.png",
    },
    {
      id: 3,
      imgUrl: "assets/language-images/drf.png",
    },
    // {
    //   id: 4,
    //   imgUrl: "assets/language-images/php.png",
    // },
    // {
    //   id: 5,
    //   imgUrl: "assets/language-images/java2.png",
    // },
    {
      id: 6,
      imgUrl: "assets/language-images/react.png",
    },
    {
      id: 7,
      imgUrl: "assets/language-images/js.png",
    },
    {
      id: 8,
      imgUrl: "assets/language-images/jq1.jpg",
    },
    {
      id: 9,
      imgUrl: "assets/language-images/html1.png",
    },
    {
      id: 10,
      imgUrl: "assets/language-images/css.png",
    },
    {
      id: 11,
      imgUrl: "assets/language-images/bts.png",
    },
    {
      id: 12,
      imgUrl: "assets/language-images/mui.png",
    },
  ];


  useEffect(() => {
  
    let technology_url = '/api/portfolio/technology/'
      HTTP.get(technology_url)
      .then(function (response) {
          console.log(response.status);
          if(response.status === 200)
          {
            // console.log(response.data)
            let data = response.data.results
            if (data.length > 0 )
            {
              setData(response.data.results)              
            }
            
          }
      })
      .catch(function (err) {
          console.log(err);
      });
  
    }, []); 
  

  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <p className="text-center contText">Skills & Technologies</p>
      <br />
      <p className="contp mb-4">
        I can build an application in below Technologies. <ArrowDownward />
      </p>

      <div className="row techRow mb-5">
        { 
          data 
          ?
          data.map((certi, index) => {
            return (
              <div key={index} className="col-3 techDiv">
                {" "}

                  <img src={certi.image} alt={certi.name} className="lanImg" />
                
              </div>
            );
          })
          :
          technologies.map((certi) => {
            return (
              <div className="col-3 techDiv">
                {" "}
                <img src={certi.imgUrl} alt="" className="lanImg" />{" "}
              </div>
            );
          })

        }
      </div>
    </div>
  );
}

export default Skill;
